<template>
  <div class="product-filter-page">
    <catalog-page-with-filters
      v-if="useCatalogPageWithFilters"
      :title="productFilter.name"
      :see-more-text="pageDescription"
      :banner="productFilter.banner_url"
      :product-filter="productFilter"
      :taxon="taxon"
      :send-gtm-data="true"
      :case-scope="productFilter.use_case_scope"
      :is-product-filter="true"
    />
    <catalog-page
      v-else
      :title="productFilter.name"
      :product-filter="productFilter"
      :taxon="taxon"
      :see-more-text="pageDescription"
      :case-scope="false"
      :banner="productFilter.banner_url"
      :send-gtm-data="true"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CatalogPage from '~/components/catalog/CatalogPage.vue'
import CatalogPageWithFilters from '~/components/catalog/CatalogPageWithFilters.vue'

export default {
  components: {
    CatalogPageWithFilters,
    CatalogPage,
  },
  props: {
    productFilter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      taxons: [],
      products: [],
    }
  },
  computed: {
    ...mapGetters(['storeInfo']),
    useCatalogPageWithFilters() {
      return ['capinha-para-celular', 'phone-cases'].includes(
        this.productFilter.slug
      )
    },
    pageDescription() {
      return (
        // eslint-disable-next-line camelcase
        this.productFilter?.page_description ||
        // eslint-disable-next-line camelcase
        this.productFilter?.seo_description
      )
    },
    taxon() {
      return {
        id: this.taxonId,
        permalink: this.taxonSlug,
      }
    },
    taxonId() {
      return this.productFilter.taxon_id
    },
    taxonSlug() {
      return this.productFilter.taxon_slug
    },
  },
}
</script>
